var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#212933",
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pagination/Default",
    transform: "translate(-237.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Next-Page",
    transform: "translate(224.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.78,11.28 C15.9206925,11.4205174 15.9998249,11.6111546 16,11.81 L16,12.19 C15.997696,12.3884141 15.918884,12.5782794 15.78,12.72 L10.64,17.85 C10.5461167,17.9446563 10.4183188,17.9978992 10.285,17.9978992 C10.1516812,17.9978992 10.0238833,17.9446563 9.93,17.85 L9.22,17.14 C9.12593593,17.0478364 9.07292856,16.9216897 9.07292856,16.79 C9.07292856,16.6583103 9.12593593,16.5321636 9.22,16.44 L13.67,12 L9.22,7.56 C9.12534367,7.4661167 9.07210084,7.33831877 9.07210084,7.205 C9.07210084,7.07168123 9.12534367,6.9438833 9.22,6.85 L9.93,6.15 C10.0238833,6.05534367 10.1516812,6.00210084 10.285,6.00210084 C10.4183188,6.00210084 10.5461167,6.05534367 10.64,6.15 L15.78,11.28 Z",
    id: "icon"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.bef0ff3a4e8830d5a3d4bedf72b9acf1.svg";
export { ForwardRef as ReactComponent };